import Cookie from "js-cookie";
import jwt_decode from "jwt-decode";
import { JwtPayLoad, JwtUser } from "../shared/jwt.interface";

export const getUserDetails = (): JwtPayLoad => {
  const token: string | undefined = Cookie.get("token");
  try {
    if (token) {
      const { firstName, lastName, role, userId, email }: JwtUser =
        jwt_decode(token);
      return {
        isLoggedIn: true,
        user: {
          userId,
          firstName,
          lastName,
          role,
          email,
        },
      };
    } else {
      return {
        isLoggedIn: false,
        user: {
          role: "",
        },
      };
    }
  } catch (e) {
    return {
      isLoggedIn: false,
      user: {
        role: "",
      },
    };
  }
};
